import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Whiteboard of mind",
  "description": "",
  "published": "2008-06-03T00:00:00.000Z",
  "redirect_from": ["/blog/whiteboard-of-mind/swizec/105"],
  "categories": "life",
  "hero": "./img/3177-2547074295_fd8bc2d275.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "375px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/e8cbbfafe60dba263977a04f2317d52d/bf173/3177-2547074295_fd8bc2d275.jpg",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "133.18385650224215%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'533\\'%20viewBox=\\'0%200%20400%20533\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M196%2035a453%20453%200%20002%2026l4-18%2011-40c2-3%201-3-8-3h-9v35m66-29c-6%2012-7%2037-4%2053%201%206%201%206%208%204l19-6%2013-4-5-3c-8-5-9-6-1-7%206-1%208-6%208-17%200-9-3-12-9-10-5%201-8%203-10%206l-2%204v-7c0-5%201-8%204-12l3-6-11-1h-10l-3%206m85-4l14%2020c2%201%201%203-2%207s-2%204%207%201c7-3%207-2%207-18%201-10%200-12-1-12l-2%202-1%202V2c-1-2-2-2-12-2h-11l1%202m39%2023l-2%201h-1l-10%205a3242%203242%200%2000-47%2016%202179%202179%200%2000-72%2026%201074%201074%200%200051-15%203077%203077%200%200077-24l-1%205-5%2025c0%205-6%203-6-2%200-2%201-3-14%202a1863%201863%200%2001-82%2021%2011412%2011412%200%2000-61%2015l-8-2-7-1-1-1-1%2068a889%20889%200%20002%2063l5-31a1115%201115%200%200014-91l2%201h8l9-3a2595%202595%200%2000109-24l9-2%2011-2c10-2%2010-2%208%209a1040%201040%200%2000-13%2058%202228%202228%200%2001-16%2063c0%203-4%207-5%205-1-1%200-2%201-2v-21l-2%203c-2%203-3%2012-8%2038a1732%201732%200%2000-17%20113c-1%206-1%206-5%206l-5%201c-3%201-5%204-3%204l1%204-1%204c-2%200-2%201-2%204l-1%204-1-4v-4h-4c-4%200-4%200-4%202l-1%203-2%202%202%201%201%201c0%201-7%207-9%207l-4%203-6%202c-4%200-5%200-5%202l4%201%204%201-3%201-6%201-3-1%202-1c2-1%202-1-1-1-2%200-3%200-2%201l-2%201h-2l-3%201c-1-1-1-1%201-2%201-1%201-1-2-1-2%201-3%200-4-1l-8-4-8-4-4-2-4-1-16-9-15-8v-6a748%20748%200%20016-67%20272%20272%200%20011-22l-1%202-2%202v-4l-1-4-1%207a36738%2036738%200%2001-8%2062c-2%2013-2%2014-5%2015-4%202-5%202-3-2%202-3%201-4-1-2l-11%206-6%202-9%204-8%203-7%202-2%201h-3c-1-1-13%204-14%206l-2%201c-3%200-11%207-10%2010%200%202-3%204-5%203l-7%204-11%205-3%202-4%202c-3-1-8%204-8%207%201%201%200%203-1%204l-2%204-1%204c-2%201-2%201-2-1l1-2%201-6c1-6%203-10%204-10v-1c-3-2%206-19%2010-19v-1l1-1c1%201%202%200%203-1s0-1-2-1l-2-1%202-1c3-2%204-5%202-8l-5%204-10%2019a171%20171%200%2001-18%2032l-5%201v-2a177%20177%200%200017-31l3-6%206-9%202-4c-2-1-13%2014-19%2026l-10%2016c-10%2014-11%2019-4%2018%202-1%203-1%202%201h1l2%201c0%201%202%203%205%204s5%203%205%204l2%201%201%201-8-1-7-3a885%20885%200%2001-41-17v11l12%206c13%206%2014%208%2010%2010l-3%203c-2%203-3%203-3-1%200-3-1-3-3-2l-3%202%202%201c3%201%203%201%201%202-3%201-5%201-5-1s-1-2-4-2H0v96h401v-77l-1-185V163h-8l-8-1c0-3-8-3-8%200l1-12%201-10%207-42c9-59%2010-60%208-60h-2c-2-1-2-4-1-6%202-1%202-3%201-6-2-3-3-4-5-1M1%20334l1%2047a1350%201350%200%200133-9l15%206%201%201%202-2%2011-17c1-1%202-2%201-3%200-2%202-3%202-1h4l3-2%203-3-2-1-4-1-30-12c-1-1%200-1%206-1h6c-4-1-5-2-5-5%200-2%200-3-3-3l-4-2c-2-4-7-9-10-9l-3-3-3-2c-2%200-3-1-4-4l-3-4c-2%200-4-1-6-4l-6-4-1-2-2-4c-2-2-2%202-2%2044\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/e8cbbfafe60dba263977a04f2317d52d/ca0a1/3177-2547074295_fd8bc2d275.webp 223w", "/static/e8cbbfafe60dba263977a04f2317d52d/f3a60/3177-2547074295_fd8bc2d275.webp 375w"],
                "sizes": "(max-width: 375px) 100vw, 375px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/e8cbbfafe60dba263977a04f2317d52d/853b2/3177-2547074295_fd8bc2d275.jpg 223w", "/static/e8cbbfafe60dba263977a04f2317d52d/bf173/3177-2547074295_fd8bc2d275.jpg 375w"],
                "sizes": "(max-width: 375px) 100vw, 375px",
                "type": "image/jpeg"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/e8cbbfafe60dba263977a04f2317d52d/bf173/3177-2547074295_fd8bc2d275.jpg",
                "alt": "new whiteboard",
                "title": "whiteboard",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`whiteboard`}</figcaption>{`
  `}</figure></p>
    <p>{`Got a new whiteboard at work yesterday. Often been needing one, but since I didn't have one of my own I was left hanging and had to rely on mental imagery, which tends to take a little longer because the mind often drifts, loses focus, and it's a general pain in the arse having to think so hard as to see a large algorithm in your head.`}</p>
    <p>{`The board came in a large package and it was like christmas all over, but somehow I managed to restrain myself to opening it only after I'd finished most of my work. The huge huge bubblewrap ... thing ... I took home and had my way with it. Those things are awesome!`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      